const metricDefinitions = [
  { streamId: '05', label: 'temperature', unit: '°C' },
  { streamId: '0A', label: 'windTemperature', unit: '°C' },
  { streamId: '09', label: 'coilTemperature', unit: '°C' },
  { streamId: '07', label: 'voltage', unit: 'V' },
  { streamId: '08', label: 'current', unit: 'A' }
]

function createRealtimeMetricRows(labels) {
  return metricDefinitions.map(definition => ({
    streamId: definition.streamId,
    monitorName: labels[definition.label],
    monitorValue: '',
    unit: definition.unit
  }))
}

function mergeRealtimeMetric(rows, item) {
  const row = rows.find(metric => metric.streamId === String(item.streamId).toUpperCase())
  if (row) {
    Object.assign(row, item)
  }
  return rows
}

function hasMonitorValue(item) {
  return !!item && item.available !== false && item.monitorValue !== null && item.monitorValue !== undefined && item.monitorValue !== ''
}

function formatRunStatus(value, labels) {
  const normalized = value === null || value === undefined ? '' : String(value)
  if (normalized === '0') {
    return labels.manual
  }
  if (normalized === '1') {
    return labels.timing
  }
  return labels.unreported
}

function formatBinaryStatus(value, labels) {
  const normalized = value === null || value === undefined ? '' : String(value)
  if (normalized === '0') {
    return labels.zero
  }
  if (normalized === '1') {
    return labels.one
  }
  return labels.unreported
}

function isCurrentRequest(requestId, currentRequestId, requestContext, currentContext) {
  return requestId === currentRequestId
    && requestContext.onenetId === currentContext.onenetId
    && requestContext.devCode === currentContext.devCode
}

export {
  createRealtimeMetricRows,
  mergeRealtimeMetric,
  hasMonitorValue,
  formatRunStatus,
  formatBinaryStatus,
  isCurrentRequest
}
